import { useState, useEffect } from 'react';

export default function StickyHeader() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToApplication = () => {
    const applicationSection = document.getElementById('application');
    if (applicationSection) {
      applicationSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header 
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-gradient-to-b from-black/30 to-transparent'
      }`}
    >
      <div className="mx-auto flex h-20 items-center justify-between px-6">
        {/* Logo */}
        <div className="font-serif text-2xl font-light">
          <span className={`transition-colors duration-300 ${isScrolled ? 'text-black' : 'text-white'}`}>
            <span className="italic">Clique</span>
          </span>
        </div>

        {/* Apply Button */}
        <button
          onClick={scrollToApplication}
          className="bg-amber-400 px-8 py-3 text-sm font-medium tracking-widest text-black transition-all duration-300 hover:bg-amber-500 whitespace-nowrap cursor-pointer"
        >
          APPLY NOW
        </button>
      </div>
    </header>
  );
}
